import { FormBuilder, FormGroup } from '@angular/forms';
import { DynamicFormFieldDefinition } from './dynamic-entity-definition';

export function createCrudFormGroup<TModel extends object>(
  formBuilder: FormBuilder,
  fields: DynamicFormFieldDefinition<TModel>[],
  source: Partial<TModel>
): FormGroup {
  const controls: Record<string, any> = {};

  for (const field of fields) {
    const key = field.key as keyof TModel;
    const sourceValue = source[key] as unknown;
    const fallbackValue = field.defaultValue as unknown;

    controls[String(key)] = formBuilder.control(
      (sourceValue ?? fallbackValue ?? null) as any,
      {
        validators: field.validators,
        asyncValidators: field.asyncValidators,
      }
    );
  }

  return formBuilder.group(controls);
}
